import { Link } from "react-router-dom";
import { InputContainer } from "./user-notifications-section";
import { connect } from "react-redux";
import { RootState } from "../../redux/root-store";

const PRIVACY_POLICY_URL = "https://www.networknerd.app/privacy-policy";
const TERMS_CONDITIONS_URL = "https://www.networknerd.app/terms-conditions";
const CONTACT_US_URL =
    "mailto:admin@networknerd.app?subject=NetworkNerd Question&body=Please describe how we can help! We aim to respond to all inquiries within 2-3 business days.";

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface AccountPackageProps extends ReturnType<typeof mapStateToProps> {}

const AccountPackage = connect(
    mapStateToProps,
    {}
)((props: AccountPackageProps) => {
    if (!props.loggedUser) return <div>Account not logged in</div>;
    let planName = props.loggedUser.purchase_name || "";
    if (planName.startsWith("NetworkNerd "))
        planName = planName.substr("NetworkNerd ".length);
    return <div>Account: {planName}</div>;
});

const AppInfoSection = () => {
    return (
        <section id="app-info" className="flex flex-col">
            <h4>Settings</h4>
            <Link to={"/profile"}>
                <InputContainer className="text-black">
                    Profile Settings
                </InputContainer>
            </Link>
            <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                <InputContainer className="text-black">
                    Privacy Policy
                </InputContainer>
            </a>
            <Link to={"/purchase"}>
                <InputContainer className="text-black">
                    <AccountPackage />
                </InputContainer>
            </Link>
            <a
                href={TERMS_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                <InputContainer className="text-black">
                    Terms & Conditions
                </InputContainer>
            </a>
            <a href={CONTACT_US_URL} target="_blank" rel="noopener noreferrer">
                <InputContainer className="text-black">
                    Contact Us
                </InputContainer>
            </a>
        </section>
    );
};

export default AppInfoSection;
